export interface ItemsMapping {
  [id: number]: string;
}
export abstract class ColorsService {
  static actionColors: ItemsMapping = {
    [1]: "teal",
    [2]: "light-green darken-3",
    [3]: "deep-orange darken-4",
    [4]: "pink",
    [5]: "purple",
    [6]: "blue lighten-4"
  };

  static wasteTypeColors: ItemsMapping = {
    [1]: "indigo",
    [2]: "deep-purple",
    [3]: "blue",
    [4]: "cyan",
    [5]: "lime",
    [6]: "deep-orange",
    [7]: "brown",
    [8]: "blue-grey",
    [9]: "light-green",
    [10]: "indigo accent-2",
    [11]: "lime darken-4",
    [12]: "indigo accent-2",
    [13]: "deep-orange darken-3",
    [14]: "brown darken-3",
    [15]: "blue-grey darken-3",
    [16]: "light-green darken-2",
    [17]: "lime darken-4",
    [18]: "purple darken-4",
    [19]: "cyan darken-3",
    [20]: "deep-purple darken-4",
    [21]: "blue darken-4",
    [22]: "pink darken-4"
  };

  static moduleColors: ItemsMapping = {
    [1]: "blue-grey",
    [2]: "lime",
    [3]: "deep-orange",
    [4]: "brown"
  };
}
